import { ADMIN_EMAILS } from "@/lib/fields";

/** Same rule as the old admin and functions/wa/logic.check_admin: allowlisted email, verified. */
export function isAllowed(user: { email: string | null; emailVerified: boolean } | null): boolean {
  if (!user?.email || !user.emailVerified) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
}
